/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  branch Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_HALF_MADE_PRODUCT(state, halfMadeProduct) {
    state.halfMadeProducts.unshift(halfMadeProduct);
    state.totalDataRow++;
  },
  SET_HALF_MADE_PRODUCT(state, res) {
    state.halfMadeProducts = res.items
    state.totalDataRow = res.totalCount;
  },
  UPDATE_HALF_MADE_PRODUCT(state, halfMadeProduct) {
    const halfMadeProductIndex = state.halfMadeProducts.findIndex((p) => p.id == halfMadeProduct.id)
    Object.assign(state.halfMadeProducts[halfMadeProductIndex], halfMadeProduct)
  },
  REMOVE_HALF_MADE_PRODUCT(state, halfMadeProductId) {
    const halfMadeProductIndex = state.halfMadeProducts.findIndex((p) => p.id == halfMadeProductId)
    state.halfMadeProducts.splice(halfMadeProductIndex, 1)
  },
}
